import { mdlMedmalCovers } from "./mdlMedmalCovers";
import { MedmalPromoMdl } from "./MedmalPromoMdl";


export class MedmalProposal {
    public ProposalNo: string;//
    public ProposalDate: Date | string;//
    public ProposalEffFrom: Date | string;//
    public ProposalEffTo: Date | string;//
    public ProposalPeriod: string;//
    public ProposalId: string;
    public ProductCode: string;//
    public SchemeCode: string;//
    public Insured_IDNo: string;//
    public Insured_Name: string;//
    public Insured_Name_Ar: string;
    public Insured_DOB: Date | string | null;//
    public Insured_DOB_G: string;//
    public Insured_DOB_H: string;//
    public Insured_DOB_exits: boolean;//
    public Insured_Nationality: string;//
    public Insured_MobileNo: string;//
    public Insured_PhoneNo: string;//
    public Insured_EmailId: string;//
    public Insured_HospId: string;//
    public Insured_PositionHeld: string;//
    public Insured_Professioncode: string;//
    public Insured_JoinDate: Date | string;//
    public Insured_BuildingNo: string;
    public Insured_AdditionalCode: string;
    public Insured_AreaName: string;
    public Insured_UnitNo: string;
    public Insured_StreetName: string;
    public Insured_DistName: string;

    public Insured_City: string;
    public Insured_POBoxNo: string;
    public Insured_PostalCode: string;
    public Insured_WBuildingNo: string;
    public Insured_WPostalCode: string;
    public Insured_WAreaName: string;
    public Insured_WAdditionalCode: string;
    public Insured_POPostalCode: string;
    public Insured_PoPoboxNo: string;
    public Insured_WCity: string;
    public Insured_POCity: string;
    public WaselAddress: boolean;
    public POBoxAddress: boolean;
    public Insured_Address1: string;
    public Insured_Address2: string;
    public Insured_Salary: string;
    public PresentDutiesDesc: string;
    public IndemnityCode: string;
    public DiscountType: string;
    public DiscountPercentage: number;
    public DiscountAmount: number;
    public TotalPremium: number;

    public Grosspremium: number;
    public Netpremium: number;
    public Prefix: string;
    public ISVIP: string;
    public claimObj: claims = new claims();
    public coverList: Array<Covers> = new Array<Covers>();
    public Covers: Array<mdlMedmalCovers> = new Array<mdlMedmalCovers>();
    public expList: Array<ExpDetials> = new Array<ExpDetials>();
    public qualList: Array<Qualification> = new Array<Qualification>();

    public SepecialtermsDesc: string;
    public NoofPatients_PerYear: string;
    public NoofOperation_PerYear: string;

    public isCancelled: boolean;
    public cancelDetails: string;
    public prevInsurance: string;
    public surgeryInfo: string;

    public st: MedmalstatusMdl = new MedmalstatusMdl();
    public Lng: string;
    public PortalRegNo: string;
    public UserID: string;
    public Insured_Name_Exists: boolean;
    public Gender: string;
    public Gender_Exists: boolean;
    public IDOBStr: string;
    public IDOB: Date | string | null;
    public IDOB_Exists: boolean;
    public HDOB: string;
    public HDOB_Exists: boolean;
    public NatNameEn: string;
    public NatNameAr: string;
    public Nat_Exists: boolean;

    public IPoBoxNo: string;
    public IPostalcode: string;
    public ICity: string;
    public AddressType: string;

    public addExp: boolean;
    public addQual: boolean;
    public SponsorID: string;
    public IDExpiry: string;
    public PreSig: string;

    public BankCode: string;
    public IBAN: string;

    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;

    public VATPercent: number;
    public VATAmount: number;
    public BeforeVATPremium: number;


    public PromoCode: string;
    public PromoDiscount: number;
    public PromoDiscountPer: number;
    public PromoID: number;
    public isPromoApply: string;
    public BeforePromoAmt: number;
    public PromoType: string;
    public PROMO_DISC_TYPE: string;


    public OldProposalNo: string;
    public PrevProposalNo: string;
    public OldPolicyNo: string;
    public PrevPolicyNo: string;
    public isRenewal: string;

    public saudiFetched: boolean;
    public PostCityFetched: boolean;

    public CrossSellDiscountPer: number;
    public CrossSellDiscountAmt: number;
    public CrossCellingDisType: string;

    public buildingNumberExists: boolean;
    public additionalNumberExists: boolean;
    public districtExists: boolean;
    public postCodeExists: boolean;
    public streetNameExists: boolean;
    public cityExists: boolean;

    public YknSaudiLogId: string;
    public YakeenLogidInsured: string;
    public MedmalProposalTrackingObj: MedmalProposalTrackingReqMdl = new MedmalProposalTrackingReqMdl();
    public promoobj: MedmalPromoMdl = new MedmalPromoMdl();
    public UPRVAT: number;

    public IsHigherPosition: boolean;
    public HigherPositionCode: number;
    public ReferredBy: string;
    public AmericanID: string;

    /* public frontImage: string;
     public backImage: string;
     public leftImage: string;
     public rightImage: string;
     public chasisImage: string;*/


    // public PreviousPolicyNo:string;
    public PrevPolicyFromDate: string = "";
    public PrevPolicyToDate: string = "";

    public IsProvidedPrvRetroDate: boolean;
    public PrevPolicyRetroDate: string = "";

    public IsRetroDateExists : boolean;
    public RetroActiveDate: string = "";
    public IsAdditionalRetro: Boolean;
    public AdditionalRetroDate: string = "";
    public ExtPeriodCode: number = 0;
    public DeductableCode: number |undefined;

    public IsICPrvPolicy: boolean;

    public BasicPremium: number;
    public DeductableLoadPer: number;
    public DeductableLoadAmt: number;
    public ExtPeriodLoadPer: number;
    public ExtPeriodLoadAmt: number;
    public RetroDateLoadPer: number;
    public RetroDateLoadAmt: number;
    public AddRetroDateLoadPer: number;
    public AddRetroDateLoadAmt: number;

    public PreferCommLang: string;
    public PreferCommChannel: string;

    public Attachment1:string;
    public Attachment2:string;
    public Attachment3:string;
    public Attachment4:string;

    public Insured_HospitalName: string;
}

export class claims {
    public claim1: boolean | null;
    public claim2: boolean | null;
    public claim3: boolean | null;
    public claimsInfo: string | null;
    public NoOfClaims: number | undefined;
    public TotalClaimsAmount: number | undefined;

}
export class Covers {
    public CoverCode: string;
    public CoverDescEn: string;
    public CoverDescAr: string;
    public LoadingTypes: string;
    public RateType: string;
    public Price: number;
    public Period: number;
    public Quantity: number;
    public Amount: number;
    public isBrokercomm: boolean;
    public IsBasic: boolean;
    public IsMandatory: boolean;
    public IsDefault: boolean;
    public IsAddToSI: boolean;
    public PremLogiccode: string;
    public TariffId: number;
    public SumInsured: number;
    public IsChecked: boolean;
    public Isdisable: boolean;
    public VATPercent: number;
    public VATAmount: number;
}
export class ExpDetials {
    public Position: string;
    public Period: string;
    public Activities: string;
    public Location: string;
}
export class Qualification {
    public Degree: string;
    public QualificationDate: string;
    public University: string;
    public Location: string;
}

export class MedmalProposalTrackingReqMdl {
    public ScreenNo: string;
    public JSONStr: string;
    public RegNo: number;
    public IndemnityCode: string;
    public SchemeCode: string;
    public ProposalPeriod: number;
    public HospId: string;
    public Professioncode: string;
    public ProposalId: number;
    public ProposalNo: number;
    public st: MedmalstatusMdl = new MedmalstatusMdl();
}

export class MedmalstatusMdl {
    public StatusCode: string;
    public StatusDescEn: string;
    public StatusDescAr: string;
    public Remarks: string;
    public MsgKey: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MedmalProposal.ts